import React from "react";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import classes from "../criteriaSubmission.module.css";
import OptionsDropDown from "../../UI/options_drop_down/options_drop_down";
import { showText } from "../../../constants";
import { selectFormData, selectFormType } from "../../../slices/form";

const TypeOfTest = ({ isLoading, handleInputChange }) => {
  const formData = useSelector(selectFormData);

  const { show_text } = formData || {};
  const formType = useSelector(selectFormType);
  const contentName = (formType === "reading") ? "text" : "content";

  return (
    <div className={classes["input-container"]} style={{ width: "100%" }}>
      <div>
        <label className={classes.formLabel} htmlFor="testType">
          Will students have access to the {contentName} when taking the test?&nbsp;
        </label>

        <Tooltip
          title={
            <React.Fragment>
              <Typography color="inherit">Open book</Typography>
              {
                "Open book assessments assume that students can access the uploaded content while answering the questions. Open book assessments focus primarily on comprehension."
              }
              <br />
              <Typography color="inherit">Closed book</Typography>
              {
                "Closed book assessments assume that students don’t have access to the uploaded content while answering the questions. Closed book assessments evaluate both knowledge and comprehension."
              }
            </React.Fragment>
          }
        >
          <InfoOutlinedIcon style={{ fontSize: 17 }} aria-label="Test type information" />
        </Tooltip>
      </div>
      <OptionsDropDown
        options={[{ name: "None selected", value: "" }, ...showText]}
        name="show_text"
        isRequired={true}
        onChangeHandler={handleInputChange}
        isDisabled={isLoading}
        value={show_text || ""}
      />
    </div>
  );
};
export default TypeOfTest;
